<template>
  <div class="header-content">
    <HeaderImage
      v-if="page.image"
      :image="page.image"
      :image-mobile="page.imageMobile"
      :alt="page.imageLegend || page.title || ''"
      class="background-image"
    />
    <div class="layer-container">
      <div class="layer">
        <div
          v-if="page.supTitle"
          class="top-content"
        >
          {{ capitalize(page.supTitle) }}
        </div>
        <div
          v-else
          class="top-content"
        >
          {{ page.type }} {{ page.subject }}
        </div>
        <div
          v-if="page.rating"
          class="score"
        >
          <ScoreResult
            :score="page.rating"
            :big="true"
          />
        </div>
        <h1>{{ capitalize(page.title) }}</h1>
        <div
          v-if="page.pegi"
          class="pegi"
        >
          <img
            v-if="page.pegi"
            :src="`/icons/PEGI_${page.pegi}.svg`"
            :alt="`pegi ${page.pegi}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CommunityPostInfo } from '~/types'

defineProps<{
  page: CommunityPostInfo
}>()
</script>

<style lang="scss" scoped>
.header-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90vh;
  max-height: 73rem;

  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: cover;
    object-position: top;
  }

  .layer {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    max-width: 56.6rem;
    height: 100%;
    padding: 0 8rem;
    background: rgba(#000, 0.6);

    .top-content {
      margin-bottom: 1.7rem;
      color: rgba($white, 0.5);
      font-size: 1rem;
      font-weight: 500;
      text-transform: uppercase;
    }

    h1 {
      color: $white;
      font-family: SST;
      font-size: 3.2rem;
      font-weight: 400;
      letter-spacing: 0;
    }

    .score {
      margin-bottom: 1.7rem;
    }

    .pegi {
      width: 3.65rem;
      height: 4.6rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .subtitle {
    max-width: 37.4rem;
    margin-top: 2rem;
    color: $white;
    font-size: 1.2rem;
    line-height: 1.6rem;
  }

  .button-point-item {
    position: absolute;
    bottom: 14rem;
    left: 8rem;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 0;
    height: 0;
    border-width: 0 0 5rem 100vw;
    border-style: solid;
    border-color: transparent transparent $white transparent;
  }
}

@media screen and (max-width: 700px) {
  .header-content {
    .layer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 0 2.5rem;

      .top-content {
        width: 100%;
      }
    }

    .button-point-item {
      position: relative;
      bottom: auto;
      left: auto;
      margin-top: 5rem;
    }
  }
}

@media screen and (min-width: 2000px) {
  .header-content {
    .layer-container {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(50vw - 100rem + 56.6rem);
      height: 100%;
      background: rgba(#000, 0.6);

      .layer {
        right: 0;
        left: auto;
        background: transparent;
      }
    }
  }
}
</style>
